import baseapi from "./../baseAPI";
import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";


export const DashboardAPI = async (setFreshLeadCount, setTotalCount, setLoading, setNotifications) =>
{
    setLoading(true);    

    try 
    {

        const [freshcount, totalcount, followupdata] = await Promise.all([
                                                                      baseapi.get("/api/publisher/dashboard/fresh-lead-count"),
                                                                      baseapi.get("/api/publisher/dashboard/total-lead-count"),
                                                                      baseapi.get("/api/publisher/dashboard/today-followup"),
                                                                ]);
        
        setLoading(false);

        console.log(freshcount.data.datacount);
        setFreshLeadCount(freshcount.data.datacount);
        setTotalCount(totalcount.data.datacount);
        setNotifications(followupdata.data.datalist);
        
    } 
    catch (error) 
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}

export const exportLeadAPI =async () =>{

    try
    {
        const response = await baseapi.get('/api/publisher/lead/export', {
                                responseType: 'blob'
                        });

        const blob = new Blob([response.data], { type: 'text/csv' });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Publisher_Lead_Export.csv');

        document.body.appendChild(link);
        link.click();

        link.remove();

        window.URL.revokeObjectURL(url);

    }
    catch (error)
    {
        console.error("Download error:", error);
    }
}

